__turbopack_context__.v({
  "conditions": "CreditConditions-module-scss-module__0_A5tG__conditions",
  "conditions__actionWrapper": "CreditConditions-module-scss-module__0_A5tG__conditions__actionWrapper",
  "conditions__title": "CreditConditions-module-scss-module__0_A5tG__conditions__title",
});
